import { Button, Col, DatePicker, Form, Input, Modal, notification, Row } from 'antd';
import { plantApi } from 'api/plantApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectUserInfo } from 'components/Layout/homeSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import { plantActions } from 'features/Plant/plantSlice';
import { plantForm, plantInfo } from 'models';
import moment from 'moment';
import * as React from 'react';
import { sidebarActions } from '../Sidebar/sidebarSlice';
import style from './Modal.module.scss';
export interface AddEditFormPlantProps {
  isEvent: boolean;
  itemPlant: plantInfo | undefined;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
}

export default function AddEditFormPlant({
  isEvent,
  itemPlant,
  isModalVisible,
  setIsModalVisible,
}: AddEditFormPlantProps) {
  const [form] = Form.useForm();
  const [itemPlantInfo, setItemPlantInfo] = React.useState<any>();
  const userInfo = useAppSelector(selectUserInfo);
  const isDisable = useAppSelector(selectIsDisable);
  const [userId, setUserId] = React.useState<string>('');
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (userInfo !== undefined) {
      setUserId(userInfo.id);
    }
  }, [userInfo, dispatch]);
  React.useEffect(() => {
    if (itemPlant !== undefined) {
      setItemPlantInfo({
        address: itemPlant.address,
        azimuth: itemPlant.azimuth,
        children: itemPlant.children,
        code: formatCode(itemPlant.code),
        lat: itemPlant.coordinantes ? itemPlant.coordinantes.lat : null,
        long: itemPlant.coordinantes ? itemPlant.coordinantes.long : null,
        elevation: itemPlant.elevation,
        id: itemPlant.id,
        installation_date: moment(itemPlant.installation_date),
        label: itemPlant.label,
        system_size: itemPlant.system_size,
        tilt: itemPlant.tilt,
        type: itemPlant.type,
      });
    }
  }, [itemPlant]);

  const formatCode = (string: string) => {
    if (string.length <= 0) return 0;
    return string.substr(1, string.length - 1);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (values: plantForm) => {
    try {
      if (!isEvent) {
        const plantItem = {
          code: formatCodeItemPlant(values.code),
          label: values.label,
          address: values.address,
          azimuth: values.azimuth === undefined ? 0 : Number(values.azimuth),
          elevation: values.elevation === undefined ? 0 : Number(values.elevation),
          installation_date:
            values.installation_date === undefined
              ? moment().valueOf()
              : Number(values.installation_date),
          system_size: values.system_size === undefined ? 0 : Number(values.system_size),
          tilt: values.tilt === undefined ? 0 : Number(values.tilt),
          coordinantes:
            values.lat === undefined || values.long === undefined
              ? null
              : {
                  lat: Number(values.lat),
                  long: Number(values.long),
                },
        };
        await plantApi.add(plantItem);
        openNotificationWithIcon('success', 'create plant successfully');
        await dispatch(
          plantActions.fetchPlantList({ id: userId, text: null, page_size: 10, page: 0 })
        );
        await dispatch(sidebarActions.fetchSidebarList(userId));
      } else {
        const plantEdit = {
          id: itemPlantInfo.id,
          code: formatCodeItemPlant(values.code),
          label: values.label,
          address: values.address,
          azimuth: values.azimuth === undefined ? 0 : Number(values.azimuth),
          elevation: values.elevation === undefined ? 0 : Number(values.elevation),
          installation_date:
            values.installation_date === undefined
              ? moment().valueOf()
              : Number(values.installation_date),
          system_size: values.system_size === undefined ? 0 : Number(values.system_size),
          tilt: values.tilt === undefined ? 0 : Number(values.tilt),
          coordinantes:
            values.lat === undefined || values.long === undefined
              ? null
              : {
                  lat: Number(values.lat),
                  long: Number(values.long),
                },
        };
        await plantApi.update(plantEdit);
        await dispatch(plantActions.fetchPlantInfo({ type: 'plant_id', id: itemPlantInfo.id }));
        openNotificationWithIcon('success', 'Update plant successfully');
        await dispatch(
          plantActions.fetchPlantList({ id: userId, text: null, page_size: 10, page: 0 })
        );
        await dispatch(sidebarActions.fetchSidebarList(userId));
      }
    } catch (error) {
      openNotificationWithIcon('error', 'please check the data again!');
    }
    setIsModalVisible(false);
    form.resetFields();
  };

  const formatCodeItemPlant = (code: string) => {
    const count = code.length;
    let newCode;
    if (count === 1) {
      newCode = `P000${code}`;
    } else if (count === 2) {
      newCode = `P00${code}`;
    } else if (count === 3) {
      newCode = `P0${code}`;
    } else {
      newCode = `P${code}`;
    }
    return newCode;
  };

  return (
    <Modal
      visible={isModalVisible}
      footer={
        <div className={style.footer_modal}>
          <Button onClick={handleCancel} className={style.btn_cancel}>
            Cancel
          </Button>
          <Button disabled={isDisable} onClick={() => form.submit()} className={style.btn_submit}>
            Submit
          </Button>
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        initialValues={itemPlantInfo}
        layout="vertical"
        hideRequiredMark
        onFinish={(values) => handleOk(values)}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="code"
              label="Code :"
              rules={[
                { required: true, message: 'Please enter Label' },
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
              ]}
              validateTrigger="onBlur"
            >
              <Input
                addonBefore="P"
                maxLength={3}
                placeholder="Please enter Code"
                disabled={isEvent}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="label"
              label="Label :"
              rules={[{ required: true, message: 'Please enter Label' }]}
            >
              <Input placeholder="Please enter Label" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="address"
              label="Address"
              rules={[{ required: true, message: 'Please enter your address' }]}
            >
              <Input placeholder="Please enter your address" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="system_size"
              label="System Size (kWp):"
              rules={[
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
              ]}
            >
              <Input placeholder="Please enter your System Size" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="elevation"
              label="Elevation (m):"
              rules={[
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
              ]}
            >
              <Input placeholder="please enter Elevation" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="azimuth"
              label="Azimuth (Degrees):"
              rules={[
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
              ]}
            >
              <Input placeholder="Please enter Azimuth" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="tilt"
              label="Tilt (Degrees):"
              rules={[
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
              ]}
            >
              <Input placeholder="Please enter Tilt" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="lat"
              label="Latitude"
              rules={[
                {
                  pattern:
                    /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/,
                  message: 'Value should contain just number',
                },
              ]}
            >
              <Input placeholder="please enter Latitude" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="long"
              label="Longitude"
              rules={[
                {
                  pattern:
                    /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/,
                  message: 'Value should contain just number',
                },
              ]}
            >
              <Input placeholder="please enter Longitude" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="installation_date" label="Install Date">
              <DatePicker
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
                disabled={isEvent}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
